import React from 'react'
import Modal from 'react-modal'
import styles from './emailServerConfigDialog.scss'
import cs from 'classnames'
import nesProp from 'nested-property'
import {connect} from 'react-redux'
import i18n from 'lib/i18n'

const _ = i18n('emailSenderConfigDialog')

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        wordWrap: "break-word"
	},
}

@connect((state) => ({
    senderEmailAddress: state.emailSender.senderEmailAddress
}))
export default class EmailServerConfigDialog extends React.Component {
	static propTypes = {
        modalIsOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
    }
    constructor(props) {
        super(props)
		this.state = {senderName: '', hasError: false, errorMessage: ''}
    }

	render() {
        const {modalIsOpen, onCancel, onConfirmation, senderEmailAddress, dispatch} = this.props
        const {senderName, hasError, errorMessage} = this.state

        const config = {
            emailAddress: senderEmailAddress,
            senderName
        }

		return (
            <div>
				<Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>{_('emailConfigModalTitle')}</div>
                        <div className={styles.contentWrapper}>
                            <div className={styles.content}>
                                <div className={styles.formInputContainer}>
                                    <label className={styles.formLabel}>{_('emailAddressInUse')}:</label>
                                    <span>{senderEmailAddress}</span>
                                </div>
                              
                                <div className={styles.formInputContainer}>
                                    <label className={styles.formLabel}>{_('senderName')}:*
                                    </label>
                                    <input
                                        className={cs(styles.formInput, styles.formInputText)}
                                        type="text"
                                        value={senderName}
                                        placeholder={_('senderNamePlaceholder')}
                                        onChange={(e) => {
                                            this.setState({senderName: e.target.value})
                                        }}
                                        onBlur={() => {
                                            if(!senderName){
                                                this.setState({hasError: true, errorMessage: _('senderNameError')})
                                            }else if(senderName && senderName.includes('@')){
                                                this.setState({hasError: true, errorMessage: _('invalidCharacter')})
                                            }else(
                                                this.setState({hasError: false})
                                            )
                                        }}
                                        ref="senderName"
                                        name="senderName"
                                    />
                                </div>
                            <div>
                                <div className={styles.errorMessage}>
                                    {hasError && errorMessage}
                                </div>
                            </div>
                            </div>
                            <div className={styles.buttons}>
                                <div
                                    onClick={onCancel}
                                    className={ styles.cancel }
                                >
                                    {_('cancel')}
                                </div>
                                <div
                                    onClick={() => {
                                        if(!senderName){
                                            this.setState({hasError: true})
                                            return
                                        }
                                        if(hasError){
                                            return
                                        }
                                        onConfirmation(config)}}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {_('confirm')}
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/emailSender/emailServerConfigDialog.jsx